import { Action } from '@ngrx/store';
import { Resource } from 'src/app/shared/models/resource.model';
import { Translation } from 'src/app/shared/models/translation.model';

import { FilterTranslate } from '../filter-translate.model';

/**Descrizione per il tipo UpdateFilter */
export const UPDATE_FILTER = '[TRAD] Update filters';

/**Descrizione per il tipo SelectResource */
export const SELECT_RESOURCE = '[TRAD] Risorsa selezionata';

export const SET_SELECTION_TABLE_ROW = '[TRAD] Azione di selezione di una riga in tabella traduzioni';
export const SET_SECONDARY_SELECTION_TABLE_ROWS = '[TRAD] Azione di selezione di righe secondarie in tabella traduzioni';

/**Azione di selezione del nodo risorsa selezionato in navigazione */
export class SelectResource implements Action {
    readonly type = SELECT_RESOURCE;

    /**
     * Costruttore per l'azione SelectResource
     * @param payload {Resource} risorsa selezionata
     */
    constructor(public payload: Resource) {}
}

/**Azione di aggiornamento dei valori dei filtri nella pagina di traduzioni */
export class UpdateFilter implements Action {
    readonly type = UPDATE_FILTER;

    /**
     * Costruttore dell'azione UpdateFilter
     * @param payload {FilterTranslate} oggetto contenente tutti i campi di filtro
     */
    constructor(public payload: FilterTranslate) { }
}

export class SetSelectionTableRow implements Action {
    readonly type = SET_SELECTION_TABLE_ROW;

    constructor(public payload: Resource|Translation) {}
}
export class SetSecondarySelectionTableRows implements Action {
    readonly type = SET_SECONDARY_SELECTION_TABLE_ROWS;

    constructor(public payload: (Resource|Translation)[]) {}
}

/**Tipi di azioni disponibili per la sezione traduzioni dello stato */
export type TraduzioniAction =
    | SelectResource
    | UpdateFilter
    | SetSelectionTableRow
    | SetSecondarySelectionTableRows;